<template>
  <div class="settings">
    <div class="topbar__settings">
      <ul>
        <li :class="{ active: activeTab == 'audio' }" @click="showAudioTab">
          Audio
        </li>
        <li :class="{ active: activeTab == 'video' }" @click="showVideoTab">
          Camera
        </li>
        <li :class="{ active: activeTab == 'general' }" @click="showGeneralTab">
          General
        </li>
      </ul>
    </div>
    <div class="set__settings" v-if="activeTab == 'audio'">
      <h4>Microphone</h4>
      <div class="d-flex justify-content-between align-items-center set">
        <b-form-select
          class="form-control"
          @change="handleMicChange"
          v-model="currentAudioinput"
          :options="userAudioinput"
        >
        </b-form-select>
        <div>
          <span class="strength">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="settingLevel3"
                d="M16.3999 5.3C16.3999 4.58203 16.9819 4 17.6999 4C18.4179 4 18.9999 4.58203 18.9999 5.3V18.3C18.9999 19.018 18.4179 19.6 17.6999 19.6C16.9819 19.6 16.3999 19.018 16.3999 18.3V5.3Z"
                fill="none"
              />
              <path
                id="settingLevel1"
                d="M6 14.4C6 13.682 6.58203 13.1 7.3 13.1C8.01797 13.1 8.6 13.682 8.6 14.4V18.3C8.6 19.018 8.01797 19.6 7.3 19.6C6.58203 19.6 6 19.018 6 18.3V14.4Z"
                fill="none"
              />
              <path
                id="settingLevel2"
                d="M11.2002 9.20001C11.2002 8.48204 11.7822 7.90001 12.5002 7.90001C13.2182 7.90001 13.8002 8.48204 13.8002 9.20001V18.3C13.8002 19.018 13.2182 19.6 12.5002 19.6C11.7822 19.6 11.2002 19.018 11.2002 18.3V9.20001Z"
                fill="none"
              />
            </svg>
          </span>
          <span class="icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.17157 1.17157C9.92172 0.421427 10.9391 0 12 0C13.0609 0 14.0783 0.421427 14.8284 1.17157C15.5786 1.92172 16 2.93913 16 4V12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12V4C8 2.93913 8.42143 1.92172 9.17157 1.17157ZM12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4V12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12V4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2Z"
                fill="var(--theme-color)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5 9C5.55228 9 6 9.44772 6 10V12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18C13.5913 18 15.1174 17.3679 16.2426 16.2426C17.3679 15.1174 18 13.5913 18 12V10C18 9.44772 18.4477 9 19 9C19.5523 9 20 9.44772 20 10V12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12V10C4 9.44772 4.44772 9 5 9Z"
                fill="var(--theme-color)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 18C12.5523 18 13 18.4477 13 19V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V19C11 18.4477 11.4477 18 12 18Z"
                fill="var(--theme-color)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7 23C7 22.4477 7.44772 22 8 22H16C16.5523 22 17 22.4477 17 23C17 23.5523 16.5523 24 16 24H8C7.44772 24 7 23.5523 7 23Z"
                fill="var(--theme-color)"
              />
            </svg>
          </span>
        </div>
      </div>
      <br />
      <h4>Speakers</h4>
      <div class="d-flex justify-content-between align-items-center set">
        <b-form-select
          class="form-control"
          @change="handleSpeakerChange"
          v-model="currentAudiooutput"
          :options="userAudiooutput"
        >
        </b-form-select>
        <div>
          <span class="strength">
            Test
          </span>
          <span class="test-speaker icon" @click="testSpeaker">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.0016 12C20.0016 8.6719 17.9672 5.8219 15.0797 4.61721L14.3109 6.46409C16.4766 7.36877 18 9.50627 18 12C18 14.4985 16.4766 16.6313 14.3063 17.536L15.075 19.3828C17.9672 18.1781 20.0016 15.3281 20.0016 12ZM15.9984 12C15.9984 10.336 14.9812 8.91096 13.5375 8.31096L12.7687 10.1578C13.4906 10.4578 13.9969 11.1703 13.9969 12.0047C13.9969 12.8344 13.4906 13.5469 12.7687 13.8516L13.5375 15.6985C14.9812 15.0891 15.9984 13.6641 15.9984 12ZM16.6172 0.923462L15.8438 2.77034C19.4578 4.27502 21.9984 7.83752 21.9984 12C21.9984 16.1578 19.4578 19.725 15.8438 21.2297L16.6125 23.0766C20.9531 21.2672 24 16.9922 24 12C24 7.00784 20.9531 2.73284 16.6172 0.923462ZM0 6.99846V16.9969H5.43127L11.2404 22.0896V1.91047L5.43127 6.99846H0Z"
                fill="var(--theme-color)"
              />
            </svg>
          </span>
          <audio id="testSpeaker" src="@/assets/audio/YesICan.wav"></audio>
        </div>
      </div>
    </div>
    <div class="set__settings" v-if="activeTab == 'video'">
      <h4>Camera</h4>
      <div class="d-flex justify-content-between align-items-center set">
        <b-form-select
          class="form-control"
          @change="handleCameraChange"
          v-model="currentVideoinput"
          :options="userVideoinput"
        >
        </b-form-select>
        <video
          id="testVideo"
          class="test-video"
          muted
          autoplay
          playsinline
        ></video>
        <div>
          <!-- 
                <span class="strength">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.4004 4H19.0004V19.6H16.4004V4Z" fill="#DDDDDD"/>
                    <path d="M6 13.1H8.6V19.6H6V13.1Z" fill="var(--theme-color)"/>
                    <path d="M11.2002 7.90002H13.8002V19.6H11.2002V7.90002Z" fill="var(--theme-color)"/>
                    </svg>
                </span>
                <span class="icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.17157 1.17157C9.92172 0.421427 10.9391 0 12 0C13.0609 0 14.0783 0.421427 14.8284 1.17157C15.5786 1.92172 16 2.93913 16 4V12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12V4C8 2.93913 8.42143 1.92172 9.17157 1.17157ZM12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4V12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12V4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2Z" fill="var(--theme-color)"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9C5.55228 9 6 9.44772 6 10V12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18C13.5913 18 15.1174 17.3679 16.2426 16.2426C17.3679 15.1174 18 13.5913 18 12V10C18 9.44772 18.4477 9 19 9C19.5523 9 20 9.44772 20 10V12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12V10C4 9.44772 4.44772 9 5 9Z" fill="var(--theme-color)"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 18C12.5523 18 13 18.4477 13 19V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V19C11 18.4477 11.4477 18 12 18Z" fill="var(--theme-color)"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 23C7 22.4477 7.44772 22 8 22H16C16.5523 22 17 22.4477 17 23C17 23.5523 16.5523 24 16 24H8C7.44772 24 7 23.5523 7 23Z" fill="var(--theme-color)"/>
                    </svg>
                </span>
               -->
        </div>
      </div>
      <br />
    </div>
    <div class="set__settings" v-if="activeTab == 'general'">
      <b-form-checkbox
        id="diagnostics-checkbox"
        v-model="reportDiagnostics"
        name="diagnostics-checkbox"
        value="accepted"
        unchecked-value="not_accepted"
        >Report additional diagnostics to help improve SESSIONS
      </b-form-checkbox>
    </div>
  </div>
</template>
<script>
export default {
  name: "SessionSettings",
  data() {
    return {
      reportDiagnostics: true,
      activeTab: "audio",
      userAudioinput: [],
      userAudiooutput: [],
      userVideoinput: [],
      currentAudioinput: null,
      currentAudiooutput: null,
      currentVideoinput: null
    };
  },
  props: {
    micLabel: {
      type: String,
      default: null,
      required: false
    },
    cameraLabel: {
      type: String,
      default: null,
      required: false
    }
  },
  mounted() {
    this.getDevices();
    this.testMic();
  },
  methods: {
    getDevices() {
      navigator.mediaDevices
        .enumerateDevices()
        .then(devices => {
          devices.forEach(device => {
            if (device.kind == "audioinput") {
              let audio = {
                value: device.deviceId,
                text: device.label
              };
              this.userAudioinput.push(audio);
            } else if (device.kind == "audiooutput") {
              let output = {
                value: device.deviceId,
                text: device.label
              };
              this.userAudiooutput.push(output);
            } else if (device.kind == "videoinput") {
              let video = {
                value: device.deviceId,
                text: device.label
              };
              this.userVideoinput.push(video);
            }
          });
          if (this.micLabel) {
            this.userAudioinput.forEach(audio => {
              if (audio.text == this.micLabel) {
                this.currentAudioinput = audio.value;
              }
            });
          } else {
            this.currentAudioinput = this.userAudioinput[0].value;
          }
          if (this.cameraLabel) {
            this.userVideoinput.forEach(video => {
              if (video.text == this.cameraLabel) {
                this.currentVideoinput = video.value;
              }
            });
          } else {
            this.currentVideoinput = this.userVideoinput[0].value;
          }
          this.currentAudiooutput = this.userAudiooutput[0].value;
        })
        .catch(err => console.log("no devices found", err));
    },
    showAudioTab() {
      this.activeTab = "audio";
      this.testMic();
    },
    showVideoTab() {
      this.activeTab = "video";
      this.testCamera();
    },
    showGeneralTab() {
      this.activeTab = "general";
    },
    handleMicChange() {
      this.$emit("change-audio-input", this.currentAudioinput);
    },
    handleSpeakerChange() {
      this.$emit("change-audio-output", this.currentAudiooutput);
    },
    handleCameraChange() {
      this.$emit("change-video-input", this.currentVideoinput);
      this.testCamera();
    },
    testMic() {
      navigator.mediaDevices
        .getUserMedia({
          video: false,
          audio: {
            deviceId: this.currentAudioinput
              ? { exact: this.currentAudioinput }
              : undefined
          }
        })
        .then(stream => {
          var max_level_L = 0;
          var old_level_L = 0;
          var audioContext = new AudioContext();
          var microphone = audioContext.createMediaStreamSource(stream);
          var javascriptNode = audioContext.createScriptProcessor(1024, 1, 1);

          microphone.connect(javascriptNode);
          javascriptNode.connect(audioContext.destination);
          javascriptNode.onaudioprocess = function(event) {
            var inpt_L = event.inputBuffer.getChannelData(0);
            var instant_L = 0.0;

            var sum_L = 0.0;
            for (var i = 0; i < inpt_L.length; ++i) {
              sum_L += inpt_L[i] * inpt_L[i];
            }
            instant_L = Math.sqrt(sum_L / inpt_L.length);
            max_level_L = Math.max(max_level_L, instant_L);
            instant_L = Math.max(instant_L, old_level_L - 0.008);
            old_level_L = instant_L;
            let percentage = (instant_L / max_level_L) * 100;
            if (percentage == 0) {
              if (document.getElementById("settingLevel1")) {
                document.getElementById("settingLevel1").style.fill = "none";
              }
              if (document.getElementById("settingLevel2")) {
                document.getElementById("settingLevel2").style.fill = "none";
              }
              if (document.getElementById("settingLevel3")) {
                document.getElementById("settingLevel3").style.fill = "none";
              }
            } else if (percentage > 0 && percentage < 30) {
              if (document.getElementById("settingLevel1")) {
                document.getElementById("settingLevel1").style.fill =
                  "var(--theme-color)";
              }
              if (document.getElementById("settingLevel2")) {
                document.getElementById("settingLevel2").style.fill = "none";
              }
              if (document.getElementById("settingLevel3")) {
                document.getElementById("settingLevel3").style.fill = "none";
              }
            } else if (percentage > 30 && percentage < 60) {
              if (document.getElementById("settingLevel1")) {
                document.getElementById("settingLevel1").style.fill =
                  "var(--theme-color)";
              }
              if (document.getElementById("settingLevel2")) {
                document.getElementById("settingLevel2").style.fill =
                  "var(--theme-color)";
              }
              if (document.getElementById("settingLevel3")) {
                document.getElementById("settingLevel3").style.fill = "none";
              }
            } else if (percentage > 60) {
              if (document.getElementById("settingLevel1")) {
                document.getElementById("settingLevel1").style.fill =
                  "var(--theme-color)";
              }
              if (document.getElementById("settingLevel2")) {
                document.getElementById("settingLevel2").style.fill =
                  "var(--theme-color)";
              }
              if (document.getElementById("settingLevel3")) {
                document.getElementById("settingLevel3").style.fill =
                  "var(--theme-color)";
              }
            }
          };
        });
    },
    testSpeaker() {
      let audio = document.querySelector("#testSpeaker");
      audio.play();
    },
    testCamera() {
      navigator.mediaDevices
        .getUserMedia({
          audio: false,
          video: {
            deviceId: this.currentVideoinput
              ? { exact: this.currentVideoinput }
              : undefined
          }
        })
        .then(stream => {
          if (document.querySelector("#testVideo")) {
            document.querySelector("#testVideo").srcObject = stream;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.settings {
  background-color: #fff;
  padding: 16px;
  border-radius: 8px;
  max-width: 500px;
  min-width: 500px;
  .topbar__settings {
    padding: 0 20px;
    border-bottom: 1px solid #dddddd;
    ul {
      padding: 0;
      list-style-type: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0;
      li {
        cursor: pointer;
        width: 33%;
        display: inline-block;
        text-align: center;
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        padding-bottom: 14px;
        &.active {
          color: var(--theme-color);
          border-bottom: 2px solid var(--theme-color);
        }
      }
    }
  }
  .set__settings {
    padding: 18px 10px 0 10px;
    height: 165px;
    h4 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      color: #474d52;
      margin: 0;
    }
    .form-control {
      width: 80%;
      border: none;
      padding-left: 0;
      margin-left: -3px;
      &:focus {
        outline: none;
        box-shadow: none;
      }
    }
    select {
      border: none;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #474d52;
    }
    .test-video {
      width: 115px;
      height: 85px;
      z-index: 2;
      border-radius: 5px;
      background-color: #0d0d21;
    }
    .test-speaker {
      cursor: pointer;
    }
    textarea {
      width: 100% !important;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #8d99a0;
    }
    .strength {
      margin-right: 10px;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 19px;
      color: var(--theme-color);
    }
    .set {
      flex-direction: row;
    }
  }
}
@media (max-width: 560px) {
  .settings .set__settings .form-control {
    width: 50%;
  }
}
.session-content {
  .settings {
    position: absolute;
    bottom: 50px;
    left: 30vw;
    z-index: 50;
    .set__settings {
      .set {
        flex-direction: row-reverse !important;
      }
    }
  }
}
.session-content {
  .settings {
    position: absolute;
    bottom: 50px;
    left: 30vw;
    z-index: 50;
    .topbar__settings {
      ul {
        flex-direction: row-reverse !important;
      }
    }
  }
}
</style>
